export default __webpack_public_path__ + "static/media/shoes1-afterA-768w.7b712e91.png";